import { Injectable } from '@angular/core';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { AuthenticationProvider } from '@shared/shared/enums/authentication-provider.enum';
import { ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OauthService {
  public siteSettings$: Observable<ISiteSettings>;
  constructor(private siteSettingsService: SiteSettingsService) {
    this.siteSettings$ = this.siteSettingsService.fetchSiteSettings();
  }

  public isOauthEnabledSite(): boolean {
    let isOauthEnabled = false;
    this.siteSettings$.subscribe((siteSettings) => {
      if (
        siteSettings?.authentication_provider?.provider === AuthenticationProvider.creditsaison ||
        siteSettings?.authentication_provider?.provider === AuthenticationProvider.creditsaisondiamond ||
        siteSettings?.authentication_provider?.provider === AuthenticationProvider.visa_lac
      ) {
        isOauthEnabled = true;
      }
    });
    return isOauthEnabled;
  }
}
